// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section__BenefitsSection-module--Tgn0L {
    padding: var(--space-3xl) var(--space-md) var(--space-xl);
    scroll-margin-top: 80px;
}

.inner__BenefitsSection-module--SMb7C {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: var(--space-xl);
}

.heading__BenefitsSection-module--C2Uuk {
    margin: 0;
    font-size: var(--home-text-heading);
    font-weight: 800;
    letter-spacing: -0.02em;
    line-height: 1;
}

.groups__BenefitsSection-module--_GS7J {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(380px, 100%), 1fr));
    gap: var(--space-sm);
}

.group__BenefitsSection-module--ZToZu {
    display: flex;
    flex-direction: column;
    gap: var(--space-md);
    padding: var(--space-lg);
    border-radius: var(--home-radius-3xl);
    background: var(--color-surface-secondary);
}

.groupHeading__BenefitsSection-module--UWLDh {
    margin: 0;
    font-size: 24px;
    font-weight: 800;
    letter-spacing: -0.01em;
    color: var(--home-color-secondary-text);
}

/* Doubled class: vector's list reset (ul:not([class*="ant-"] ul)) outranks a single class. */
.list__BenefitsSection-module--OK6M1.list__BenefitsSection-module--OK6M1 {
    display: flex;
    flex-direction: column;
    gap: var(--space-sm);
    margin: 0;
    padding: 0;
    list-style: none;
}

.list__BenefitsSection-module--OK6M1 li {
    display: flex;
    gap: var(--space-xs);
    align-items: flex-start;
    font-size: 17px;
    line-height: 1.55;
}

.icon__BenefitsSection-module--v70rQ.icon__BenefitsSection-module--v70rQ {
    flex-shrink: 0;
    margin-top: 1px;
    font-size: 22px;
    color: var(--home-color-secondary-text);
}
`, "",{"version":3,"sources":["webpack://./src/main/ui/home/components/BenefitsSection.module.css"],"names":[],"mappings":"AAAA;IACI,yDAAyD;IACzD,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,SAAS;IACT,mCAAmC;IACnC,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sEAAsE;IACtE,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,wBAAwB;IACxB,qCAAqC;IACrC,0CAA0C;AAC9C;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,uCAAuC;AAC3C;;AAEA,6FAA6F;AAC7F;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;IACT,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,uCAAuC;AAC3C","sourcesContent":[".section {\n    padding: var(--space-3xl) var(--space-md) var(--space-xl);\n    scroll-margin-top: 80px;\n}\n\n.inner {\n    max-width: 1200px;\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-xl);\n}\n\n.heading {\n    margin: 0;\n    font-size: var(--home-text-heading);\n    font-weight: 800;\n    letter-spacing: -0.02em;\n    line-height: 1;\n}\n\n.groups {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(min(380px, 100%), 1fr));\n    gap: var(--space-sm);\n}\n\n.group {\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-md);\n    padding: var(--space-lg);\n    border-radius: var(--home-radius-3xl);\n    background: var(--color-surface-secondary);\n}\n\n.groupHeading {\n    margin: 0;\n    font-size: 24px;\n    font-weight: 800;\n    letter-spacing: -0.01em;\n    color: var(--home-color-secondary-text);\n}\n\n/* Doubled class: vector's list reset (ul:not([class*=\"ant-\"] ul)) outranks a single class. */\n.list.list {\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-sm);\n    margin: 0;\n    padding: 0;\n    list-style: none;\n}\n\n.list li {\n    display: flex;\n    gap: var(--space-xs);\n    align-items: flex-start;\n    font-size: 17px;\n    line-height: 1.55;\n}\n\n.icon.icon {\n    flex-shrink: 0;\n    margin-top: 1px;\n    font-size: 22px;\n    color: var(--home-color-secondary-text);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `section__BenefitsSection-module--Tgn0L`,
	"inner": `inner__BenefitsSection-module--SMb7C`,
	"heading": `heading__BenefitsSection-module--C2Uuk`,
	"groups": `groups__BenefitsSection-module--_GS7J`,
	"group": `group__BenefitsSection-module--ZToZu`,
	"groupHeading": `groupHeading__BenefitsSection-module--UWLDh`,
	"list": `list__BenefitsSection-module--OK6M1`,
	"icon": `icon__BenefitsSection-module--v70rQ`
};
export default ___CSS_LOADER_EXPORT___;
